const SubCategory = {

    // FIELDS
    "sub_category": "Sub Category",
    "subcategory": "Subcategory",
    "name": "Name",
    "description": "Description",
    "category": "Category",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Sub Category",
    "filter_title": "Sub Category Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_category": "Category",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Sub Category Name",
    "error_description": "Enter Description",
    "error_category": "Select Category",
    "error_status": "Select Status",

}

export default SubCategory;

